import { useQuery } from '@tanstack/vue-query'
import fetchApi from '@/utils/fetchApi'
import type { GlobalVariable } from 'shared/src'

export const variablesAllQueryKey = () => ['variables', 'all'] as const

export function useVariablesAllQuery() {
  return useQuery({
    queryKey: variablesAllQueryKey(),
    queryFn: () =>
      fetchApi<GlobalVariable[]>({
        endpoint: '/api/variables/all',
        method: 'GET',
      }),
  })
}
